export * from './kunden-sorter.component';
export * from './kunden-sorter.component.module';